import React, { FC } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Button } from "src/components/Button";
import { ButtonVariants } from "src/components/Button/types";
import { Link } from "src/components/Link";
import { PATHNAMES } from "src/constants/routes";
import { IRegisterValues } from "src/@types/auth";
import {
  registrationButtonsTrns,
  registrationDescriptionsTrns,
  registrationTitlesTrns,
} from "../trns";

export const SuccessStep: FC = () => {
  const { t } = useTranslation();
  const { values } = useFormikContext<IRegisterValues>();

  return (
    <div className="flex flex-col justify-center items-center gap-8 py-25">
      <h2 className="font-bold">{t(registrationTitlesTrns.accountCreated)}</h2>

      <p className="max-w-148 text-center">
        {t(registrationDescriptionsTrns.accountCreatedDesc, {
          email: values.email,
        })}
      </p>

      <Link href={PATHNAMES.HOME} className="max-w-148 w-full capitalize">
        <Button
          type="button"
          className="max-w-148 w-full capitalize"
          variant={ButtonVariants.PRIMARY}
        >
          <p>{t(registrationButtonsTrns.toMainPage)}</p>
        </Button>
      </Link>
    </div>
  );
};
